import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import {
  getOrCreateAgentProfile,
  updateAgentProfile,
  type AgentProfile
} from '@/data/askCircle';

export function useAgentProfile() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const { data: profile, isLoading, error } = useQuery({
    queryKey: ['agent-profile', user?.id],
    queryFn: () => {
      if (!user?.id) return null;
      return getOrCreateAgentProfile(user.id);
    },
    enabled: !!user?.id,
  });

  const updateMutation = useMutation({
    mutationFn: (updates: Partial<AgentProfile>) => {
      if (!user?.id) throw new Error('No user');
      return updateAgentProfile(user.id, updates);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agent-profile', user?.id] });
    },
  });

  return {
    profile,
    isLoading,
    error,
    updateProfile: updateMutation.mutate,
    isUpdating: updateMutation.isPending,
  };
}
